"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFieldSelector = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const StyledDiv = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  min-width: content;
  min-height: 32px;
  white-space: nowrap;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: ${p => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return typeof ((_c = (_b = (_a = p.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.body1) === null || _c === void 0 ? void 0 : _c.fontSize) === 'number'
        ? `${(_f = (_e = (_d = p.theme) === null || _d === void 0 ? void 0 : _d.typography) === null || _e === void 0 ? void 0 : _e.body1) === null || _f === void 0 ? void 0 : _f.fontSize}px`
        : ((_j = (_h = (_g = p.theme) === null || _g === void 0 ? void 0 : _g.typography) === null || _h === void 0 ? void 0 : _h.body1) === null || _j === void 0 ? void 0 : _j.fontSize) || 'inherit';
}};
  /* margin-bottom: 6px; */
  &.error {
    border: 1px solid red;
  }
  .field-empty {
    min-width: 80px;
    &::before {
      display: block;
      content: '${p => p.placeholder || ''}';
      color: #aaa;
      width: 100%;
      height: 100%;
    }
  }
  &.focus::after {
    position: absolute;
    display: block;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    border: 2px solid #333;
    border-radius: 6px;
  }
  .field-input {
    display: inline-block;
    flex: 1 1 auto;
    outline: none;
    cursor: text;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .delete-button {
    margin-left: 4px;
  }
  .MuiIcon-root {
    font-size: 16px;
  }
`;
const StyledList = styled_components_1.default.ul `
  list-style: none;
  margin: 0;
  padding: 8px 0;
  max-height: 40vh;
  overflow: auto;
  li {
    min-height: 48px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    padding-top: 6px;
    box-sizing: border-box;
    outline: 0;
    --webkit-tap-highlight-color: transparent;
    padding: 0 16px 6px 16px;
    ${p => p.theme.breakpoints.up('sm')} {
      min-height: auto;
    }
    &[aria-selected='true'] {
      background-color: ${p => p.theme.palette.action.selected};
    }
    &[data-focus='true'] {
      background-color: ${p => p.theme.palette.action.hover};
    }
    &:active {
      background-color: ${p => p.theme.palette.action.selected};
    }
    &[aria-disabled='true'] {
      opacity: ${p => p.theme.palette.action.disabledOpacity};
      pointer-events: none;
    }
  }
`;
// Number of options to jump in list box when pageup and pagedown keys are used.
const pageSize = 5;
// Redecalare forwardRef
// declare module 'react' {
//   function forwardRef<T, P = {}>(
//     render: (props: P, ref: React.Ref<T>) => React.ReactElement | null
//   ): (props: P & React.RefAttributes<T>) => React.ReactElement | null;
// }
// eslint-disable-next-line @typescript-eslint/ban-types
const QueryFieldSelector = (_a) => {
    var { freesolo, value, options, autoFocus, className, placeholder, prependElement, disabled, error, helperText, onBlur, onFocus, onChange, onFreeSoloChange, onInputChange, onDelete, onAdd, getAddLabel = value => `Add "${value}"`, getOptionLabel = option => (typeof option === 'string' ? option : ''), filterOptions = (0, lab_1.createFilterOptions)(), innerRef } = _a, props = __rest(_a, ["freesolo", "value", "options", "autoFocus", "className", "placeholder", "prependElement", "disabled", "error", "helperText", "onBlur", "onFocus", "onChange", "onFreeSoloChange", "onInputChange", "onDelete", "onAdd", "getAddLabel", "getOptionLabel", "filterOptions", "innerRef"]);
    const valueRef = (0, react_1.useRef)(value);
    const [textInput, setTextInput] = (0, react_1.useState)(getOptionLabel(value));
    const [focus, setFocus] = (0, react_1.useState)(false);
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(value);
    const elementRef = (0, react_1.useRef)(null);
    const contentEditableElementRef = (0, react_1.useRef)(null);
    const listElementRef = (0, react_1.useRef)(null);
    const highlightIndexRef = (0, react_1.useRef)(null);
    const [anchorElement, setAnchorElement] = (0, react_1.useState)();
    const getOptionLabelRef = (0, react_1.useRef)(getOptionLabel);
    (0, react_1.useEffect)(() => void (getOptionLabelRef.current = getOptionLabel), [getOptionLabel]);
    // hide popover if disabled
    (0, react_1.useEffect)(() => void (disabled && setAnchorElement(undefined)), [disabled]);
    // update selected option and text input if value changes
    (0, react_1.useEffect)(() => {
        const getOptionLabel = getOptionLabelRef.current;
        const label = getOptionLabel(value);
        if (label !== getOptionLabel(valueRef.current)) {
            setSelectedOption(value);
            setTextInput(label);
            valueRef.current = value;
        }
    }, [value]);
    // prevent pasting html content
    (0, react_1.useEffect)(() => {
        const element = contentEditableElementRef.current;
        const handlePaste = (event) => {
            var _a;
            event.preventDefault();
            const text = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/plain');
            if (text) {
                document.execCommand('insertHTML', false, text);
            }
        };
        element.addEventListener('paste', handlePaste);
        return () => {
            element.removeEventListener('paste', handlePaste);
        };
    }, []);
    // check if auto focus on contenteditable input field
    (0, react_1.useEffect)(() => {
        var _a;
        if (autoFocus) {
            (_a = contentEditableElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [autoFocus]);
    /**
     * Select an option.
     * @param option
     */
    const handleSelect = (option) => {
        const label = getOptionLabel(option);
        contentEditableElementRef.current.innerText = label;
        setSelectedOption(option);
        setTextInput(label);
        highlightIndexRef.current = null;
        setAnchorElement(undefined);
        // unfocus after selecting
        const selection = window.getSelection();
        selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
        if (option && label !== getOptionLabel(valueRef.current)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(option);
        }
    };
    /**
     * Unhighlight an option.
     * @returns
     */
    const handleUnhighlight = () => {
        const listElement = listElementRef.current;
        if (!listElement)
            return;
        const prevElement = listElement.querySelector(`[data-focus]`);
        prevElement === null || prevElement === void 0 ? void 0 : prevElement.removeAttribute('data-focus');
    };
    /**
     * Highlight an option.
     * @param index
     * @param reason
     * @returns
     */
    const handleHighlight = (index, reason = 'auto') => {
        handleUnhighlight();
        highlightIndexRef.current = index;
        const listElement = listElementRef.current;
        if (!listElement)
            return;
        const optionElement = listElement.querySelector(`[data-option-index="${index}"]`);
        optionElement === null || optionElement === void 0 ? void 0 : optionElement.setAttribute('data-focus', 'true');
        if (reason === 'mouse')
            return;
        if (optionElement && listElement.scrollHeight > listElement.clientHeight) {
            const scrollBottom = listElement.clientHeight + listElement.scrollTop;
            const elementBottom = optionElement.offsetTop + optionElement.offsetHeight;
            if (elementBottom > scrollBottom) {
                listElement.scrollTop = elementBottom - listElement.clientHeight;
            }
            else if (optionElement.offsetTop < listElement.scrollTop) {
                listElement.scrollTop = optionElement.offsetTop;
            }
        }
    };
    // get filtered results
    const filteredOptions = filterOptions(options, {
        inputValue: textInput === getOptionLabel(selectedOption) ? '' : textInput,
        getOptionLabel
    });
    const classes = ['query-field-selector'];
    if (className)
        classes.push(className);
    if (focus)
        classes.push('focus');
    if (error)
        classes.push('error');
    return (react_1.default.createElement(StyledDiv, Object.assign({}, props, { ref: element => {
            if (element) {
                elementRef.current = element;
                innerRef === null || innerRef === void 0 ? void 0 : innerRef(element);
            }
        }, className: classes.join(' '), placeholder: placeholder }),
        prependElement,
        react_1.default.createElement("div", { contentEditable: true, ref: contentEditableElementRef, className: `field-input${textInput ? '' : ' field-empty'}`, dangerouslySetInnerHTML: { __html: getOptionLabel(selectedOption) }, role: 'combobox', onClick: () => setAnchorElement(elementRef.current), onInput: event => {
                const textInput = event.currentTarget.textContent || '';
                setTextInput(textInput);
                highlightIndexRef.current = null;
                handleUnhighlight();
                onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(textInput);
            }, onBlur: event => {
                setAnchorElement(undefined);
                setFocus(false);
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                if (freesolo && textInput !== getOptionLabel(selectedOption)) {
                    onFreeSoloChange === null || onFreeSoloChange === void 0 ? void 0 : onFreeSoloChange(textInput);
                }
                else if (!freesolo &&
                    textInput !== getOptionLabel(selectedOption)) {
                    // rollback text changes if not freesolo
                    handleSelect(selectedOption);
                }
            }, onFocus: event => {
                setAnchorElement(elementRef.current);
                setFocus(true);
                onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
            }, onKeyDown: event => {
                const highlightIndex = highlightIndexRef.current;
                switch (event.key) {
                    case 'Home':
                        if (anchorElement) {
                            // Prevent scroll of the page
                            event.preventDefault();
                            handleHighlight(0);
                        }
                        break;
                    case 'End':
                        if (anchorElement) {
                            // Prevent scroll of the page
                            event.preventDefault();
                            handleHighlight(filteredOptions.length - 1);
                        }
                        break;
                    case 'PageUp':
                        // Prevent scroll of the page
                        event.preventDefault();
                        handleHighlight(highlightIndex === null
                            ? 0
                            : Math.max(highlightIndex - pageSize, 0));
                        if (!anchorElement)
                            setAnchorElement(elementRef.current);
                        break;
                    case 'PageDown':
                        // Prevent scroll of the page
                        event.preventDefault();
                        handleHighlight(highlightIndex === null
                            ? filteredOptions.length - 1
                            : Math.min(highlightIndex + pageSize, filteredOptions.length - 1));
                        if (!anchorElement)
                            setAnchorElement(elementRef.current);
                        break;
                    case 'ArrowUp':
                        // Prevent cursor move
                        event.preventDefault();
                        handleHighlight(highlightIndex === null
                            ? 0
                            : // wrap around to end if at beginning
                                highlightIndex - 1 < 0
                                    ? filteredOptions.length - 1
                                    : highlightIndex - 1);
                        if (!anchorElement)
                            setAnchorElement(elementRef.current);
                        break;
                    case 'ArrowDown':
                        // Prevent cursor move
                        event.preventDefault();
                        handleHighlight(highlightIndex === null ||
                            // wrap around to beginning if at end
                            highlightIndex + 1 > filteredOptions.length - 1
                            ? 0
                            : highlightIndex + 1);
                        if (!anchorElement)
                            setAnchorElement(elementRef.current);
                        break;
                    // case 'ArrowLeft':
                    //   handleFocusTag(event, 'previous');
                    //   break;
                    // case 'ArrowRight':
                    //   handleFocusTag(event, 'next');
                    //   break;
                    case 'Enter':
                        event.preventDefault();
                        // Wait until IME is settled.
                        if (highlightIndex === null || event.which === 229) {
                            break;
                        }
                        const option = filteredOptions[highlightIndex];
                        const listElement = listElementRef.current;
                        if (!listElement)
                            return;
                        const optionElement = listElement.querySelector(`[data-option-index="${highlightIndex}"]`);
                        if (optionElement === null || optionElement === void 0 ? void 0 : optionElement.dataset.freesolo) {
                            onAdd === null || onAdd === void 0 ? void 0 : onAdd(textInput);
                            setAnchorElement(undefined);
                        }
                        else {
                            handleSelect(option);
                        }
                        // move cursor to end
                        // const range = document.createRange();
                        // range.selectNodeContents(elementRef.current);
                        // range.collapse(false);
                        // const selection = window.getSelection();
                        // selection?.removeAllRanges();
                        // selection?.addRange(range);
                        break;
                    case 'Escape':
                        if (anchorElement) {
                            // Avoid Opera to exit fullscreen mode.
                            event.preventDefault();
                            // Avoid the Modal to handle the event.
                            event.stopPropagation();
                            // reset to value input
                            handleSelect(value);
                        }
                        break;
                    // case 'Backspace':
                    //   if (multiple && inputValue === '' && value.length > 0) {
                    //     const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                    //     const newValue = value.slice();
                    //     newValue.splice(index, 1);
                    //     handleValue(event, newValue, 'remove-option', {
                    //       option: value[index],
                    //     });
                    //   }
                    //   break;
                    default:
                        if (!anchorElement)
                            setAnchorElement(elementRef.current);
                }
            } }),
        onDelete && (react_1.default.createElement(core_1.IconButton, { size: 'small', color: 'inherit', tabIndex: -1, className: 'delete-button', onClick: () => {
                onDelete === null || onDelete === void 0 ? void 0 : onDelete();
            } },
            react_1.default.createElement(core_1.Icon, null, "close"))),
        react_1.default.createElement(core_1.Popper, { anchorEl: anchorElement, open: Boolean(anchorElement), role: 'presentation', 
            // same z-index as snackbar according to MUI documentation
            // needed to support query field selector used in MUI drawers
            style: { zIndex: 1400 } },
            react_1.default.createElement(core_1.Paper, null,
                react_1.default.createElement(StyledList, { ref: listElementRef, className: 'list', role: 'listbox', onMouseDown: event => {
                        // Prevent blur
                        event.preventDefault();
                    } },
                    filteredOptions.map((option, index) => (react_1.default.createElement("li", { key: `${getOptionLabel(option)}-${index}`, "data-option-index": index, "aria-selected": selectedOption === option, onMouseOver: () => handleHighlight(index, 'mouse'), onClick: event => {
                            event.stopPropagation();
                            handleSelect(option);
                        } }, getOptionLabel(option)))),
                    onAdd && filteredOptions.length === 0 && (react_1.default.createElement("li", { "data-option-index": 0, "data-freesolo": true, 
                        // aria-selected={true}
                        onMouseOver: () => handleHighlight(0, 'mouse'), onClick: event => {
                            event.stopPropagation();
                            onAdd(textInput);
                        } }, getAddLabel(textInput))))))));
};
exports.QueryFieldSelector = QueryFieldSelector;
exports.default = exports.QueryFieldSelector;
//# sourceMappingURL=QueryFieldSelector.js.map